.button {
  background: none;
  border: none;
  padding: 8px 9px;
  border-radius: 6px;
  color: var(--color-subtle);
}

.button:hover,
.button.selected {
  background-color: var(--color-overlay);
}

.button:active {
  background-color: var(--color-highlightHigh);
}

.button.selected {
  color: var(--color-text);
}

.button svg {
  /* octicon put "inline-block" at style */
  display: block !important;
}
